// import "./App.css";
// import { useState } from "react";
// import PlayHomeComp from "./components/playHome";
// import WalletComp from "./components/Wallet";
// import GameHistoryCont from "./components/History";
// import ProfileComp from "./components/Profile";
// import BottomNav from "./components/BottomNav";
// import BingoGamePage from "./components/BingoGamePage";
// import { theme, injectTheme } from "./assets/theme";

// function App() {
//   const [activeTab, setActiveTab] = useState("game");
//   const [onGame, setonGame] = useState(false);
//   const handleGameStart = (data) => {
//     setonGame(true);
//   };
//   const renderPage = () => {
//     switch (activeTab) {
//       case "wallet":
//         return <WalletComp />;
//       case "history":
//         return <GameHistoryCont />;
//       case "profile":
//         return <ProfileComp />;
//       default:
//         return <PlayHomeComp onGameStart={handleGameStart} />;
//     }
//   };
//   return (
//     <div
//       style={{
//         position: "relative",
//         width: "100%",
//         background: theme.color.bgSurface,
//         overflow: "hidden",
//         boxShadow: theme.shadow.phone,
//         display: "flex",
//         flexDirection: "column",
//         height: "100vh",
//       }}
//     >
//       {onGame ? (
//         <BingoGamePage />
//       ) : (
//         <>
//           {renderPage()}

//           <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} />
//         </>
//       )}
//     </div>
//   );
// }

// export default App;

import "./App.css";
import { useState } from "react";
import PlayHomeComp from "./components/playHome";
import WalletComp from "./components/Wallet";
import GameHistoryCont from "./components/History";
import ProfileComp from "./components/Profile";
import BottomNav from "./components/BottomNav";
import BingoGamePage from "./components/BingoGamePage";
import { theme } from "./assets/theme";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { GameProvider, useGame } from "./contexts/GameContext";

function AppShell() {
  const [activeTab, setActiveTab] = useState("game");
  const { loading } = useAuth();
  const { inGame } = useGame(); // <-- single source of truth, not local onGame state

  const renderPage = () => {
    switch (activeTab) {
      case "wallet":
        return <WalletComp />;
      case "history":
        return <GameHistoryCont />;
      case "profile":
        return <ProfileComp />;
      default:
        return <PlayHomeComp />; // no more onGameStart prop needed
    }
  };

  if (loading) return <div>Loading...</div>; // or a splash screen

  return (
    <div
      style={
        {
          /* ...same wrapper styles... */
        }
      }
    >
      {inGame ? (
        <BingoGamePage />
      ) : (
        <>
          {renderPage()}
          <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} />
        </>
      )}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <GameProvider>
        <AppShell />
      </GameProvider>
    </AuthProvider>
  );
}

export default App;
